"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.providerPropTypes = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var providerPropTypes = {
  emberUrl: _stencilReactDesc.PropTypes.string.description('Sets the url to configure Ember font family.'),
  emotionCache: _stencilReactDesc.PropTypes.any.description('Sets custom Emotion cache that applies CSS styles to the iframe.'),
  locale: _stencilReactDesc.PropTypes.string.description('Sets the global locale.'),
  isNested: _stencilReactDesc.PropTypes.bool.description('Indicates whether the provider is nested or not. Disables theme and font loading.'),
  isRTL: _stencilReactDesc.PropTypes.bool.description('Indicates whether layout should be right to left.'),
  shouldAddLiveAnnouncer: _stencilReactDesc.PropTypes.bool.description('Indicates whether LiveRegion should be added which enables live region announcement in certain components.'),
  shouldUseResponsiveText: _stencilReactDesc.PropTypes.bool.description('Indicates whether font sizes and line heights should scale based on viewport.'),
  theme: _stencilReactDesc.PropTypes.any.description('Sets the theme that the provider uses.'),
  mode: _stencilReactDesc.PropTypes.oneOf(['default', 'dense']).description('Sets the mode that adjusts spacing values for various components.')
};
exports.providerPropTypes = providerPropTypes;